module.exports = "/static/js/6b8683c1ed72386248a0aecc81f05702.png";